import React from 'react';
import PropTypes from 'prop-types';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import './WelcomePartial.scss';

const WelcomePartial = props => (
  <section className="welcome-partial">
    <div className="container-guttered">
      {props.firstName && props.title &&
        <p className="welcome-partial__title">
          {replaceTextWithValues(props.title, { name: props.firstName })}
        </p>
      }
      {props.description &&
        <p className="text-mega">{props.description}</p>
      }
    </div>
  </section>
);


WelcomePartial.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  firstName: PropTypes.string.isRequired,
};

export default WelcomePartial;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Account/WelcomePartial/WelcomePartial.js